var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "downloadIconSvg",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 18,
    fill: "none",
    viewBox: "0 0 15 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#85949F",
    strokeLinecap: "round",
    strokeWidth: 2.27,
    d: "M7.5 2v13.66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#85949F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.27,
    d: "M2 10.67l5.5 5.5 5.5-5.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.e2c26ac5f4a5409a5b101095c88c0534.svg";
export { ForwardRef as ReactComponent };